import CloseIcon from "@mui/icons-material/Close";
// import ErrorIcon from "@mui/icons-material/Error";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Skeleton,
  // Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ReactCountryFlag } from "react-country-flag";
import { theme } from "../../assets/theme/theme";
import jsPDF from "jspdf";
import { applyPlugin } from "jspdf-autotable";
import PageImageSrc from "../../../public/brand/background.png";
import BrandImageSrc from "../../../public/brand/Logo on White@4x.png";
import BarlowLight from "../../../public/font/Barlow-Light.ttf";
import BarlowBold from "../../../public/font/Barlow-Bold.ttf";
import { auth } from "../../config/firebase";
import { useSelector } from "react-redux";
import { StoreState } from "../../store/store";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

interface Props {
  sessionInfo: any;
  hasPaid: boolean;
}

declare module "jspdf" {
  interface jsPDF {
    autoTable: (options: any) => void;
  }
}

type SortField =
  | "ip"
  | "country"
  | "isp"
  | "domain"
  | "time"
  | "ipDetails.domain"
  | "location"
  | "timezone"
  | "photo_url";
type SortOrder = "asc" | "desc";

const TrackMasterLiveTable = ({ sessionInfo, hasPaid }: Props) => {
  const [userPaid, setUserPaid] = useState<boolean>();
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIpDetails, setShowIpDetails] = useState(false);
  const [detailsIdx, setDetailsIdx] = useState<null | number>(null);
  const [sortField, setSortField] = useState<SortField>("time");
  const [sortOrder, setSortOrder] = useState<SortOrder>("desc");
  const user = useSelector((state: StoreState) => state.user.loggedInUser);

  const formatTime = (timeString: string | number) => {
    if (!timeString) return "❌";
    try {
      // Parse as number and multiply by 1000 to convert from seconds to milliseconds
      const timestamp =
        typeof timeString === "string" ? parseInt(timeString, 10) : timeString;
      const date = new Date(timestamp * 1000);

      const formattedTime = date.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });

      return formattedTime;
    } catch (error) {
      console.log(error);
      return String(timeString);
    }
  };

  const formatIspDomain = (domainString: string) => {
    if (!domainString) return "❌";
    const parts = domainString.split("/");
    return parts[parts.length - 1] || domainString;
  };

  //We would like to change the information that is currently presented to: ID (starts wtih 1), Location, Timezone, and a button for more (to show all the information and if possibile,to issue a PDF to download with all the infomration.

  const TableHeader = () => {
    const SortableCell = ({
      field,
      children,
      className,
    }: {
      field?: SortField;
      children: React.ReactNode;
      className?: string;
    }) => (
      <TableCell
        className={className}
        onClick={field ? () => handleSort(field) : undefined}
        sx={{
          cursor: field ? "pointer" : "default",
          userSelect: "none",
          "&:hover": field ? { backgroundColor: "rgba(0,0,0,0.04)" } : {},
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {children}
          {field &&
            sortField === field &&
            (sortOrder === "asc" ? (
              <ArrowUpward fontSize="small" />
            ) : (
              <ArrowDownward fontSize="small" />
            ))}
        </Box>
      </TableCell>
    );

    if (showMore) {
      return (
        <TableHead className="trackmaster-details-header">
          <SortableCell className="trackmaster-details">#</SortableCell>
          <SortableCell field="ip" className="trackmaster-details">
            IP address
          </SortableCell>
          <SortableCell className="trackmaster-details">Location</SortableCell>
          <SortableCell field="country" className="trackmaster-details">
            Country
          </SortableCell>
          <SortableCell field="isp" className="trackmaster-details">
            ISP
          </SortableCell>
          <SortableCell field="domain" className="trackmaster-details">
            ISP Domain
          </SortableCell>
          <SortableCell
            field="ipDetails.domain"
            className="trackmaster-details"
          >
            Domain Used
          </SortableCell>
          <SortableCell field="time" className="trackmaster-details">
            Time
          </SortableCell>
          <SortableCell field="photo_url" className="trackmaster-details">
            Photo
          </SortableCell>
        </TableHead>
      );
    } else {
      return (
        <TableHead>
          <SortableCell className="trackmaster-details">#</SortableCell>
          <SortableCell field="country" className="trackmaster-details">
            Location
          </SortableCell>
          <SortableCell field="timezone" className="trackmaster-details">
            TimeZone
          </SortableCell>
          <SortableCell field="time" className="trackmaster-details">
            Time
          </SortableCell>
          <SortableCell field="photo_url" className="trackmaster-details">
            Photo
          </SortableCell>
          <SortableCell className="trackmaster-details"> </SortableCell>
        </TableHead>
      );
    }
  };

  const handleCheckIfUserPaid = () => {
    if (sessionInfo && sessionInfo.leftToPay > 0 && !hasPaid) {
      setUserPaid(false);
    } else {
      setUserPaid(true);
    }
    // } else if (sessionInfo && sessionInfo.data instanceof Array) {
    //   setUserPaid(true);
    // }
  };

  const printJustifiedLine = (
    doc: jsPDF,
    line: string,
    x: number,
    y: number,
    maxWidth: number,
    isLastLine: boolean
  ): void => {
    const words = line.split(" ");
    let currentX = x;

    // If it's the last line, use a single space width.
    // Otherwise, calculate the extra space needed for justification.
    const spaceWidth = isLastLine
      ? doc.getTextWidth(" ")
      : (maxWidth -
          words.reduce((width, word) => width + doc.getTextWidth(word), 0)) /
        (words.length - 1);

    words.forEach((word, index) => {
      doc.text(word, currentX, y);
      // Add the space width unless it's the last word in the line
      if (index < words.length - 1) {
        currentX += doc.getTextWidth(word) + spaceWidth;
      }
    });
  };

  const justifyText = (
    doc: jsPDF,
    text: string,
    x: number,
    y: number,
    maxWidth: number
  ): number => {
    const words = text.split(/\s+/);
    const lines: string[] = [];
    let line = "";
    const lineHeight = 10;

    words.forEach((word) => {
      const testLine = line + word + " ";
      const testLineWidth = doc.getTextWidth(testLine);

      if (testLineWidth > maxWidth && line !== "") {
        lines.push(line.trim());
        line = word + " ";
      } else {
        line = testLine;
      }
    });

    if (line) {
      lines.push(line.trim());
    }

    lines.forEach((currLine, index) => {
      const isLastLine = index === lines.length - 1;
      printJustifiedLine(
        doc,
        currLine,
        x,
        y + index * lineHeight,
        maxWidth,
        isLastLine
      );
    });

    // Calculate and return the final Y position after the last line
    return y + lines.length * lineHeight;
  };

  const generateInvoice = (dataItem: any) => {
    let maxWidth = 320;
    let text = "";
    // Create a new jsPDF instance
    const pageImage = new Image();
    pageImage.src = PageImageSrc;
    const brandPage = new Image();
    brandPage.src = BrandImageSrc;
    console.log(brandPage.width, brandPage.height);
    applyPlugin(jsPDF);
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const barlowLight = BarlowLight;
    const barlowBold = BarlowBold;
    doc.addFont(barlowLight, "Barlow", "light");
    doc.addFont(barlowBold, "Barlow", "bold");
    let yPosition = pageHeight / 5;
    const xPosition = 25;
    for (let i = 0; i < 10; i++) {
      doc.addImage(pageImage, pageWidth - 60, 0, 225 / 3, 389 / 3);
      doc.addImage(brandPage, 20, 15, 829 / 18, 332 / 18);
      text = "support@onlinejustice.com";
      const text_width = doc.getTextWidth(text);
      doc.setFont("Barlow", "light");
      doc.text(text, xPosition, pageHeight - 12);
      doc.setDrawColor(211, 167, 108);
      doc.line(
        text_width + xPosition + 12,
        pageHeight - 12,
        pageWidth,
        pageHeight - 12
      );
      doc.addPage();
    }
    doc.deletePage(11);
    doc.setPage(1);
    doc.setFont("Barlow", "light");
    maxWidth = 120;
    text =
      "The report contains information about the device used by the scammer, including the IP address, device information, timezone, and location details. This information can be used to identify the scammer and potentially recover the funds.";
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 10;
    doc.setFontSize(24);
    doc.setFont("Barlow", "bold");
    doc.text("Report: Scam Investigation Findings", xPosition, yPosition + 20);
    yPosition += 18;
    doc.setFontSize(20);
    doc.text(`for ${user?.fullName || user?.email}`, xPosition, yPosition + 12);
    doc.setPage(2);
    doc.setFontSize(24);
    yPosition = pageHeight / 5 - 12;
    doc.setFont("Barlow", "bold");
    doc.text("Introduction", xPosition, yPosition);
    yPosition += 18;
    doc.setFontSize(14);
    doc.setFont("Barlow", "light");
    text = `This report presents the findings of the investigation into a scam targeting ${auth.currentUser?.displayName}. The investigation aims to identify the perpetrators involved in the scam and gather relevant information that can assist in the recovery of funds. The following report provides a detailed analysis of the available data and technical information obtained from the IP address used during the fraudulent activity.`;
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 36;
    doc.setFillColor(242, 242, 242);
    doc.text("Investigation Details:", xPosition, yPosition + 12);
    doc.text("Device Information", xPosition, yPosition + 24);
    yPosition += 32;
    const columns = ["Information", "Value"];

    // Define the table data
    let data = [
      ["IP address", dataItem.ip],
      ["Device", dataItem.host],
    ];
    doc.autoTable({
      columns: columns,
      body: data,
      margin: { left: xPosition },
      startY: yPosition,
      tableWidth: maxWidth,
      styles: {
        fillColor: [220, 220, 220],
      },
      headStyles: {
        fillColor: [50, 50, 50],
        fontSize: 14,
      },
      bodyStyles: {
        fillColor: [220, 220, 220],
        fontSize: 12,
      },
    });
    yPosition += 18;
    doc.setPage(3);
    yPosition = pageHeight / 5 - 20;
    doc.text("Location Information IP2", xPosition, yPosition);
    yPosition += 12;
    data = [
      ["Response", dataItem.ipDetails.response],
      ["Country Code", dataItem.ipDetails.country_code],
      ["Country Name", dataItem.ipDetails.country_name],
      ["Region Name", dataItem.ipDetails.region_name],
      ["City Name", dataItem.ipDetails.city_name],
      ["Latitude ", dataItem.ipDetails.latitude],
      ["Longitude", dataItem.ipDetails.longitude],
      ["Zip Code", dataItem.ipDetails.zip_code],
      ["Time Zone ", dataItem.ipDetails.time_zone],
      ["ISP ", dataItem.ipDetails.isp],
      ["Domain", dataItem.ipDetails.domain],
      ["Net speed", dataItem.ipDetails.net_speed],
      ["Idd code ", dataItem.ipDetails.idd_code],
      ["Area code ", dataItem.ipDetails.area_code],
      [
        "Weather station code",
        dataItem.ipDetails.weather_station_code,
      ],
      [
        "Weather station name",
        dataItem.ipDetails.weather_station_name,
      ],
      ["MCC", dataItem.ipDetails.mcc],
      ["MNC", dataItem.ipDetails.mnc],
      ["Elevation", dataItem.ipDetails.elevation],
      ["Usage type ", dataItem.ipDetails.usage_type],
      ["Address type", dataItem.ipDetails.address_type],
      ["Category", dataItem.ipDetails.category],
      ["Category name", dataItem.ipDetails.category_name],
      ["Credits Consumed ", dataItem.ipDetails.credits_consumed],
    ];
    doc.autoTable({
      columns: columns,
      body: data,
      margin: { left: xPosition },
      startY: yPosition,
      tableWidth: maxWidth,

      styles: {
        fillColor: [220, 220, 220],
      },
      headStyles: {
        fillColor: [50, 50, 50],
        fontSize: 14,
      },
      bodyStyles: {
        fillColor: [220, 220, 220],
        fontSize: 12,
      },
    });
    doc.setPage(4);
    yPosition = pageHeight / 5 - 12;
    doc.setFontSize(24);
    doc.setFont("Barlow", "bold");
    doc.text("Technical Analysis", xPosition, yPosition);
    yPosition += 18;
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    text = `Based on the investigation into the device associated with the IP address ${dataItem.ip}, the following information has been identified:`;
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 16;
    text = `The IP address is located in ${dataItem.ipDetails.city_name}, ${dataItem.ipDetails.region_name}, ${dataItem.country}, with coordinates ${dataItem.ipDetails.latitude}° N latitude and ${dataItem.ipDetails.longitude}° E longitude. The timezone for this location is ${dataItem.ipDetails.city_name}. The zip code for this area is ${dataItem.ipDetails.zip_code}, and the time zone is ${dataItem.ipDetails.time_zone}.`;
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 16;
    text = `The device associated with this IP address utilizes the Chrome browser version 115.0.0.0 on the Windows 10 operating system. The user agent string reveals the Device information as ${dataItem.host}.`;
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 16;
    text = `The device is connected to the domain ${dataItem.ipDetails.domain}. The net speed is categorized as ${dataItem.ipDetails.category}. The IDD code is ${dataItem.ipDetails.idd_code}, and the area code is ${dataItem.ipDetails.area_code}.`;
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 16;
    text = ``;
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    doc.setPage(5);
    yPosition = pageHeight / 5 - 12;
    text = `The findings suggest that the device associated with the IP address ${dataItem.ip} is located in ${dataItem.ipDetails.city_name}, ${dataItem.country}  and is linked to ${dataItem.ipDetails.domain}. It is categorized as a device in a data center and falls under the Data Centers category. By analyzing the IP address, device details, and associated data, you can take several steps to assist in your efforts to get your money back. Here's how this information can be used:`;
    doc.setFontSize(12);
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 18;
    doc.setFontSize(20);
    doc.setFont("Barlow", "bold");
    doc.text("Contact Law Enforcement Authorities", xPosition, yPosition);
    yPosition += 18;
    text = `Based on the IP address, which indicates the location of the device used in the scam as ${dataItem.ipDetails.city_name}, ${dataItem.ipDetails.region_name}, ${dataItem.country}, you should promptly file a complaint with the appropriate law enforcement agency in that jurisdiction. Specifically, contact the ${dataItem.ipDetails.city_name} Police Service and provide them with a detailed report of the scam. Your complaint should consist a chronological account of the scam events and the interactions with the perpetrator(s), the Online Justice’s full report contains your IP address, the device details, the location data, and the other technical evidence, including any additional evidence you may have (emails, messages, financial transaction details etc.) You should include your identity and contact information as the victim in your report.`;
    doc.setFont("Barlow", "light");
    doc.setFontSize(12);
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 6;
    doc.setPage(6);
    yPosition = pageHeight / 5 - 12;
    text = `You can file a report online at the ${dataItem.ipDetails.city_name} Police Service website or by visiting your local division in person. Cooperate fully with the investigator(s) assigned to your case and provide any further information or evidence requested promptly.`;
    doc.setFont("Barlow", "light");
    doc.setFontSize(12);
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 6;
    text =
      "Obtain an official case/incident number and the contact information of the investigator(s) handling your report for future reference.";
    doc.setFont("Barlow", "light");
    doc.setFontSize(12);
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 18;
    doc.setFontSize(20);
    doc.setFont("Barlow", "bold");
    doc.text("Collaborate with Cybersecurity Experts", xPosition, yPosition);
    yPosition += 18;
    text = `Consult with cybersecurity professionals who specialize in cyber fraud, scams, and online crimes. Depending on the specifics of your case, it may be wise to consult with seasoned cyber security experts to help you figure out what the best legal strategy is. They may recommend additional steps to secure your personal information, mitigate any ongoing risks, and increase the chances of recovering your funds. Cybersecurity experts are able to deeply investigate this data using specific instruments and more developed means apart from those known traditionally. This can help to identify criminal's digital traces, connect him with any wrong doing as well as provide more proof to back up the criminal case at hand.`;
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 18;
    doc.setPage(7);
    yPosition = pageHeight / 5 - 12;
    doc.setFontSize(20);
    doc.setFont("Barlow", "bold");
    doc.text("Seek Legal Assistance", xPosition, yPosition);
    yPosition += 18;
    text = `Given the complexity of cybercrime cases and the potential legal, ramifications, it is crucial to engage the services of a reputable legal professional with specific expertise in handling cybercrimes, fraud, and online offenses. Provide them with the comprehensive report from Online Justice, including the IP address, device information, location data, and any other relevant evidence you have gathered.`;
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 18;
    text = `A knowledgeable legal professional who specializes in cyber crimes may provide you with a lot of assistance on what legal choices are accessible to you, be it civil or criminal. They will evaluate the weaknesses and strengths of your case, give you some feedback about the possibility of the case being won, and suggest the best option for your particular situation. They can initiate proceedings against the perpetrator(s) on your behalf and support you throughout the process of recovering your funds.`;
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    doc.setPage(8);
    yPosition = pageHeight / 5 - 12;
    doc.setFontSize(20);
    doc.setFont("Barlow", "bold");
    doc.text("Coordinate with the ISP", xPosition, yPosition);
    yPosition += 18;
    text = `The ISP (Internet Service Provider) associated with the IP address, Microsoft Corporation in this case, can be contacted to report the scammer's activities. It is a good idea to contact the ISP about what the scammer did, show the ISP the collected proof, comprising IP address, device details, physical address and a summary of the fraudulent events. There are teams in place at the nternet Service Providers that are focused on these issues, and which have specific procedures set up to handle complaints regarding illegal activities carried out over their networks. One way of starting off this procedure is through reporting that criminal’s IP address so as to allow them conduct their inhouse operational systems geared towards recognizing the individual user behind such IP address for purpose of suspending or stopping the account said user has been engaged in fraudulent activities.The ISP may collaborate with law enforcement and provide additional information that can aid in identifying the scammer.`;
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 18;
    doc.setFontSize(20);
    doc.setFont("Barlow", "bold");
    doc.text("Preserve Evidence", xPosition, yPosition);
    yPosition += 18;
    text = "Ensure that you keep a record of all communications, ";
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    doc.setPage(9);
    yPosition = pageHeight / 5 - 12;
    yPosition += 6;
    text =
      "transactions, and any other evidence related to the scam. This includes emails, chat logs, screenshots, and financial transaction details. Preserve this evidence as it may be crucial for investigations and legal proceedings.";
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 6;
    text = "To effectively preserve evidence, follow these best practices:";
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    text =
      "- Create backup copies of all relevant data on secure external storage devices or cloud storage services.";
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    text =
      "- Do not alter or edit any original files, as maintaining their integrity is crucial for legal proceedings.";
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    text =
      "- Document the date, time, and circumstances support@onlinejustice.com surrounding each piece of evidence collected.";
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 6;
    text =
      "It's important to note that pursuing scammers and recovering funds can be complex and time-consuming. It is recommended to work closely with professionals who specialize in fraud investigations and legal matters. They can guide you through the process, provide support, and increase the chances of a successful outcome.";
    doc.setFontSize(12);
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 6;
    text =
      "Remember to exercise caution and avoid taking any unauthorized actions that may compromise your safety or hinder the investigation.";
    doc.setFontSize(12);
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    doc.setPage(10);
    yPosition = pageHeight / 5 - 12;
    doc.setFontSize(20);
    doc.setFont("Barlow", "bold");
    doc.text("Disclaimer", xPosition, yPosition);
    yPosition += 18;
    text =
      "This report is based on the information available at the time of analysis and should not be considered as definitive proof or conclusive evidence. The IP addresses and device information are subject to change as they may be masked or manipulated by the perpetrators. Further investigation is required to uncover additional details and determine the full extent of the scam";
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 6;
    text =
      "This information is provided for general guidance only and does not constitute legal advice. Consult qualified legal counsel and cybercrime experts to receive advice specific to your situation. Online Justice and I assume no liability for damages arising from actions based on this guidance.";
    doc.setFontSize(12);
    doc.setFont("Barlow", "light");
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 6;
    text =
      "If you have any questions or require further assistance, please feel free to contact us";
    doc.setFontSize(12);
    yPosition = justifyText(doc, text, xPosition, yPosition, maxWidth);
    yPosition += 6;
    doc.text("Sincerely,", xPosition, yPosition);
    yPosition += 6;
    doc.text("Investigation Analyst", xPosition, yPosition);
    yPosition += 6;
    doc.text("OnlineJustice", xPosition, yPosition);
    doc.save(`${sessionInfo.id}.pdf`);
  };

  // const handleParseObject = (obj: any) => {

  //     const result = []

  //     for (const [key, value] of Object.entries(obj)) {
  //         result.push(`${key}: ${value}`);
  //     }
  //     return result
  // }

  const handleSort = (field: SortField) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const getSortedData = (data: any[]) => {
    if (!data) return [];

    return [...data].sort((a, b) => {
      let aValue: any;
      let bValue: any;

      // Handle nested properties
      if (sortField === "ipDetails.domain") {
        aValue = a.ipDetails?.domain || "";
        bValue = b.ipDetails?.domain || "";
      } else if (sortField === "timezone") {
        aValue = a.ipDetails?.time_zone || "";
        bValue = b.ipDetails?.time_zone || "";
      } else if (sortField === "location") {
        aValue = a.country || "";
        bValue = b.country || "";
      } else if (sortField === "photo_url") {
        // Sort photos: entries with photos first, then without
        aValue = a.photo_url ? "1" : "0";
        bValue = b.photo_url ? "1" : "0";
      } else {
        aValue = a[sortField];
        bValue = b[sortField];
      }

      // Handle different data types
      if (sortField === "time") {
        aValue = typeof aValue === "string" ? parseInt(aValue, 10) : aValue;
        bValue = typeof bValue === "string" ? parseInt(bValue, 10) : bValue;
      } else if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue?.toLowerCase() || "";
      }

      if (aValue < bValue) {
        return sortOrder === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortOrder === "asc" ? 1 : -1;
      }
      return 0;
    });
  };

  useEffect(() => {
    handleCheckIfUserPaid();
  }, [sessionInfo]);

  if (!sessionInfo) {
    return null;
  } else {
    return (
      <div style={{ position: "relative" }}>
        {userPaid && (
          <Button
            onClick={() => {
              setShowMore(!showMore);
            }}
          >
            {showMore ? "Show Less" : "Show More"}
          </Button>
        )}

        {/* {!userPaid && sessionInfo.data != 0 ? (
          <Stack direction={"row"} gap={1}>
            <ErrorIcon color="error" />
            <Typography color={"error"}>
              The data can be seen after the payment has been made in full.
            </Typography>
          </Stack>
        ) : null} */}

        <Table>
          {userPaid ? (
            <>
              <TableHeader />
              <TableBody className={`wrap`}>
                {showMore &&
                  getSortedData(sessionInfo?.data || []).map(
                    (row: any, idx: number) => {
                      return (
                        <TableRow key={idx}>
                          <TableCell>{idx + 1}</TableCell>
                          <TableCell>{row.ip}</TableCell>
                          {row.ipDetails?.longitude &&
                          row.ipDetails?.latitude ? (
                            <TableCell>
                              <a
                                target="_blank"
                                href={`https://www.google.com/maps/search/${row.ipDetails.latitude}+${row.ipDetails.longitude}`}
                              >
                                📍&nbsp;&nbsp;Map
                              </a>
                            </TableCell>
                          ) : (
                            <TableCell>❌</TableCell>
                          )}
                          <TableCell className="table-tool">
                            <ReactCountryFlag
                              countryCode={row.ipDetails?.country_code}
                              svg
                              style={{
                                width: "2em",
                                height: "2em",
                              }}
                              title={row.country}
                            />
                            <br />
                            {row.country}
                          </TableCell>
                          <TableCell>{row.isp}</TableCell>
                          <TableCell>{formatIspDomain(row.domain)}</TableCell>
                          <TableCell>{row.ipDetails.domain}</TableCell>
                          <TableCell>{formatTime(row.time)}</TableCell>
                          <TableCell>
                            {row.photo_url ? (
                              <a
                                href={row.photo_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: theme.palette.primary.main,
                                  textDecoration: "underline",
                                }}
                              >
                                View Photo
                              </a>
                            ) : (
                              "❌"
                            )}
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              onClick={() => generateInvoice(row)}
                            >
                              Download Result
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                {!showMore &&
                  getSortedData(sessionInfo?.data || []).map(
                    (info: any, idx: number) => {
                      return (
                        <TableRow key={info.id}>
                          <TableCell>{idx + 1}</TableCell>
                          <TableCell sx={{ color: theme.palette.primary.main }}>
                            {info.ipDetails?.longitude &&
                            info.ipDetails?.latitude ? (
                              <TableCell>
                                <a
                                  target="_blank"
                                  href={`https://www.google.com/maps/search/${info.ipDetails.latitude}+${info.ipDetails.longitude}`}
                                >
                                  📍&nbsp;&nbsp;Map
                                </a>
                              </TableCell>
                            ) : (
                              <TableCell>❌</TableCell>
                            )}
                          </TableCell>
                          <TableCell>
                            <ReactCountryFlag
                              countryCode={info.ipDetails?.country_code}
                              svg
                              style={{
                                width: "2em",
                                height: "2em",
                              }}
                              title={info.country}
                            />
                            <br />
                            {info.country ? info.country : "❌"}
                          </TableCell>
                          <TableCell>{formatTime(info.time)}</TableCell>
                          <TableCell>
                            {info.photo_url ? (
                              <a
                                href={info.photo_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: theme.palette.primary.main,
                                  textDecoration: "underline",
                                }}
                              >
                                View Photo
                              </a>
                            ) : (
                              "❌"
                            )}
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              onClick={() => generateInvoice(info)}
                            >
                              Download Result
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </>
          ) : null}
          {!userPaid && sessionInfo.data != 0 ? (
            <>
              <TableHeader />
              {Array.from({ length: sessionInfo.data }, (_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton width={"50px"} height={"50px"} />
                  </TableCell>
                  <TableCell sx={{ fontSize: "10px" }}>
                    <Skeleton width={"200px"} height={"50px"} />
                  </TableCell>
                  <TableCell>
                    <Skeleton width={"150px"} height={"50px"} />
                  </TableCell>
                  <TableCell>
                    <Skeleton width={"100px"} height={"50px"} />
                  </TableCell>
                  <TableCell>
                    <Skeleton width={"120px"} height={"50px"} />
                  </TableCell>
                </TableRow>
              ))}
            </>
          ) : null}
          {!userPaid && sessionInfo.data?.length === 0 ? (
            <h2
              style={{ textAlign: "center", fontSize: "20px", color: "#000" }}
            >
              There is no relevant information for this product yet, the
              information will be updated live as soon as it is available.
            </h2>
          ) : null}
        </Table>
        {!userPaid && sessionInfo.data?.length > 0 && (
          <>
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(5px)",
                position: "absolute",
                top: "0px",
                left: "0px",
              }}
            >
              <p>To see the result please complete the payment.</p>
            </div>
          </>
        )}

        {/* <FocusTrap open={showIpDetails}> */}

        <Modal
          open={showIpDetails}
          onKeyDown={(e) => {
            if (e.code === "Escape") setShowIpDetails(false);
          }}
        >
          <Box
            className="tool-form-wrapper"
            sx={{ display: showIpDetails ? "flex" : "none" }}
          >
            <Box className={`overlay `}>
              <Box className={`popup`}>
                <Box className="section-header-modal">
                  <Box className="section-details">
                    <Box className="section-title-form">
                      <Typography variant="h1" sx={{ alignSelf: "baseline" }}>
                        {" "}
                        IP Details
                      </Typography>
                    </Box>
                    <Box className="section-actions">
                      <IconButton
                        onClick={() => {
                          setShowIpDetails(false);
                          setDetailsIdx(null);
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
                <Box className="popup-body">
                  {detailsIdx != null && (
                    <>
                      <Typography>
                        Response:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.response}
                      </Typography>
                      <Typography>
                        Country Code:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.country_code}
                      </Typography>
                      <Typography>
                        Country Name:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.country_name}
                      </Typography>
                      <Typography>
                        Region Name:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.region_name}
                      </Typography>
                      <Typography>
                        City Name:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.city_name}
                      </Typography>
                      <Typography>
                        latitude:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.latitude}
                      </Typography>
                      <Typography>
                        longitude:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.longitude}
                      </Typography>
                      <Typography>
                        Zip Code:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.zip_code}
                      </Typography>
                      <Typography>
                        Time Zone:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.time_zone}
                      </Typography>
                      <Typography>
                        ISP: {sessionInfo.data[detailsIdx].ipDetails.isp}
                      </Typography>
                      <Typography>
                        Domain: {sessionInfo.data[detailsIdx].ipDetails.domain}
                      </Typography>
                      <Typography>
                        Net Speed:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.net_speed}
                      </Typography>
                      <Typography>
                        Idd Cod:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.idd_cod}
                      </Typography>
                      <Typography>
                        Area_code:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.area_code}
                      </Typography>
                      <Typography>
                        Weather Station Code:{" "}
                        {
                          sessionInfo.data[detailsIdx].ipDetails
                            .weather_station_code
                        }
                      </Typography>
                      <Typography>
                        Weather Station name:{" "}
                        {
                          sessionInfo.data[detailsIdx].ipDetails
                            .weather_station_name
                        }
                      </Typography>
                      <Typography>
                        MCC: {sessionInfo.data[detailsIdx].ipDetails.mcc}
                      </Typography>
                      <Typography>
                        MNC: {sessionInfo.data[detailsIdx].ipDetails.mnc}
                      </Typography>
                      <Typography>
                        Mobile Brand:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.mobile_brand}
                      </Typography>
                      <Typography>
                        Elevation:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.elevation}
                      </Typography>
                      <Typography>
                        Usage Type:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.usage_type}
                      </Typography>
                      <Typography>
                        Address Type:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.address_type}
                      </Typography>
                      <Typography>
                        Usage Type:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.usage_type}
                      </Typography>
                      <Typography>
                        Category:{" "}
                        {sessionInfo.data[detailsIdx].ipDetails.category}
                      </Typography>
                      <Typography>
                        Credits_consumed:{" "}
                        {
                          sessionInfo.data[detailsIdx].ipDetails
                            .credits_consumed
                        }
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
        {/* </FocusTrap> */}
      </div>
    );
  }
};

export default TrackMasterLiveTable;
